import * as React from "react";
import i18next from "i18next";
import { useState } from "react";
import { useMapContext } from "../../Contexts/MapContext";
import { PopupButton } from "../../Elements/PopupButton";
import { useAppContext } from "../../Contexts/AppContext";
import { downloadMapSheets, ISheetDownloadResult } from "../rest";
import { useMapDownloadContext } from "../../Contexts/MapDownloadContext";
import "./SheetDownload.scss";

export const SheetDownload = (): JSX.Element => {
    const { activeToken, language } = useAppContext();
    const { configA } = useMapContext();
    const { sheetFeatures } = useMapDownloadContext();

    const [loading, setLoading] = useState<boolean>(false);
    const [downloadUrl, setDownloadUrl] = useState<string>();
    const [downloadErrorMessage, setDownloadErrorMessage] = useState<string>();

    const startDownload = async () => {
        if (loading || sheetFeatures.length <= 0) {
            return;
        }

        const gridNumbers = sheetFeatures.map((f) => f.get("Karšu lapas numurs"));
        setDownloadUrl(null);
        setDownloadErrorMessage(undefined);
        setLoading(true);

        const result: ISheetDownloadResult = await downloadMapSheets(
            gridNumbers,
            activeToken,
            configA.endpoints[configA.geotelpa.endpoint]
        );

        setDownloadUrl(result.fileUrl);
        setLoading(false);

        result?.error &&
            setDownloadErrorMessage(
                result?.error?.error?.error_description?.find((err) => err.language === language)?.description ||
                    i18next.t("mapDownload.error")
            );
    };

    return (
        <>
            <div className="authorization-button">
                <PopupButton title={i18next.t("mapDownload.download")} onClick={startDownload} loading={false} />
            </div>
            <div className="download-result unselectable">
                <div>{i18next.t("mapDownload.downloadMapFile")}</div>
                <div className="info-text small">
                    {downloadUrl ? <DownloadUrl downloadUrl={downloadUrl} /> : null}
                    {loading ? <Loading /> : null}
                    {downloadErrorMessage ? <div>{downloadErrorMessage}</div> : null}
                    {!loading && !downloadUrl && !downloadErrorMessage ? (
                        <div>{i18next.t("mapDownload.downloadMapFileDescription")}</div>
                    ) : null}
                </div>
            </div>
        </>
    );
};

const Loading = () => (
    <div className="download-result-file">
        <a target="_blank" className="download-url">
            <div className="spinner-small" />
            <span className="result-info">{i18next.t("mapDownload.downloadInProgress")}</span>
        </a>
    </div>
);

const DownloadUrl = ({ downloadUrl }: { downloadUrl: string }) => (
    <div className="download-result-file">
        <a target="_blank" rel="noopener noreferrer" className="download-url" href={downloadUrl}>
            <div className="icon-geolite-sync-data-down" />
            <span className="result-info">{i18next.t("mapDownload.downloadUrlText")}</span>
        </a>
    </div>
);
